import { useState } from 'react';
import Icon from './Icon';
import './ExtraCard.css';

/**
 * ExtraCard — carte produit extra (boisson, sauce, viande supplémentaire).
 * L'emoji vient des données backend (extra.emoji) — pas hardcodé ici.
 */
export default function ExtraCard({ extra, quantite, onChanger }) {
  const [pulse, setPulse] = useState(false);
  const epuise = extra.epuise === true;

  function augmenter() {
    if (epuise) return;
    onChanger(quantite + 1);
    setPulse(true);
    setTimeout(() => setPulse(false), 300);
  }

  function diminuer() {
    if (quantite > 0) onChanger(quantite - 1);
  }

  return (
    <div
      className={[
        'extra-card',
        quantite > 0 ? 'extra-card-active' : '',
        pulse       ? 'extra-card-pulse'  : '',
        epuise      ? 'epuise'            : '',
      ].filter(Boolean).join(' ')}
    >
      {/* Icône sémantique de catégorie */}
      <div className="extra-icone">
        {extra.categorie === 'boisson'      && <Icon name="panier"   size={24} weight="regular" color="currentColor" />}
        {extra.categorie === 'sauce'        && <Icon name="sauce"    size={24} weight="regular" color="currentColor" />}
        {extra.categorie === 'extra_viande' && <Icon name="repas"    size={24} weight="regular" color="currentColor" />}
        {!['boisson','sauce','extra_viande'].includes(extra.categorie) && (
          <Icon name="package" size={24} weight="regular" color="currentColor" />
        )}
      </div>

      <div className="extra-nom">{extra.nom}</div>

      {extra.description && (
        <div className="extra-desc">{extra.description}</div>
      )}

      {epuise ? (
        <div className="extra-epuise-overlay">
          <Icon name="erreur" size={14} weight="fill" color="currentColor" />
          Non disponible
        </div>
      ) : (
        <>
          <div className="extra-prix">
            {parseFloat(extra.prix).toFixed(2).replace('.', ',')}&nbsp;$
            <span className="extra-unite"> / {extra.unite || 'unité'}</span>
          </div>
          <div className="extra-qty">
            <button
              className="extra-qty-btn"
              onClick={diminuer}
              disabled={quantite === 0}
              aria-label={`Retirer ${extra.nom}`}
            >
              −
            </button>
            <span className="extra-qty-val">{quantite}</span>
            <button
              className="extra-qty-btn"
              onClick={augmenter}
              aria-label={`Ajouter ${extra.nom}`}
            >
              +
            </button>
          </div>
          {quantite > 0 && (
            <div className="extra-sous-total">
              {(extra.prix * quantite).toFixed(2).replace('.', ',')}&nbsp;$
            </div>
          )}
        </>
      )}
    </div>
  );
}
